import { render, staticRenderFns } from "./PropertyListing.vue?vue&type=template&id=2010bb54"
import script from "./PropertyListing.vue?vue&type=script&lang=js"
export * from "./PropertyListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports